import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import Switch from 'react-switch'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const BarleyPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    GrainSize: item.GrainSize,
    BarleyVerification: item.BarleyVerification,
    Organic: item.Organic,
  })

  const methods = useFormContext()
  const { setSwitchReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { GrainSize, BarleyVerification, Organic } = item
      setPackaging({
        GrainSize,
        BarleyVerification,
        Organic,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            name="GrainSize"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.GrainSize}
            control={methods.control}
            rules={{
              validate: GrainSize => GrainSize >= 12 && GrainSize <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="GrainSize"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <p>
          <strong>
            I certify that this is a whole grain barley product and is not
            pearled barley. {asterisk}
          </strong>
        </p>
        <Controller
          as={Switch}
          name="BarleyVerification"
          id="BarleyVerification"
          defaultValue={packaging.BarleyVerification}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          control={methods.control}
          rules={{
            validate: BarleyVerification => BarleyVerification === true,
          }}
          disabled={isDisabled}
        />
        <br />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="BarleyVerification"
            message={'⚠ Product must be barley.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <hr />
        <p>
          <strong>Organic</strong>
        </p>
        <Controller
          as={Switch}
          name="Organic"
          id="Organic"
          control={methods.control}
          defaultValue={item.Organic}
          onChange={([checked, event, id]) => {
            setSwitchReviewer(item, checked, event, id)
            return checked
          }}
          disabled={isDisabled}
        />
      </Col>
    </Row>
  )
}

BarleyPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BarleyPackageReview
